__turbopack_context__.v({
  "badge": "YourWins-module__S2eQkG__badge",
  "container": "YourWins-module__S2eQkG__container",
  "header": "YourWins-module__S2eQkG__header",
  "prizeGrid": "YourWins-module__S2eQkG__prizeGrid",
  "separator": "YourWins-module__S2eQkG__separator",
  "wrapper": "YourWins-module__S2eQkG__wrapper",
});
